import { render } from "./RoleCard.vue?vue&type=template&id=25b3c5a0&scoped=true"
import script from "./RoleCard.vue?vue&type=script&lang=js"
export * from "./RoleCard.vue?vue&type=script&lang=js"

import "./RoleCard.vue?vue&type=style&index=0&id=25b3c5a0&lang=scss&scoped=true"
import "./RoleCard.vue?vue&type=style&index=1&id=25b3c5a0&lang=scss"

import exportComponent from "D:\\NET\\AsdCare\\asdcare-internal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25b3c5a0"]])

export default __exports__